// extracted by mini-css-extract-plugin
module.exports = {"player":"antd-pro-containers-recordngs-styles-player","playBtn":"antd-pro-containers-recordngs-styles-playBtn"};